import type { Field, Theme, FontPairing } from "@structurify/shared-types";
import { TypeGlyph } from "../components/primitives/index.ts";

interface Props {
  fields: Field[];
  theme: Theme;
  fonts: FontPairing;
}

const thStyle = (theme: Theme, fonts: FontPairing) => ({
  textAlign: "left" as const,
  padding: "10px 14px",
  fontFamily: fonts.mono,
  fontSize: 9,
  letterSpacing: "0.08em",
  textTransform: "uppercase" as const,
  color: theme.inkMute,
  fontWeight: 500,
  borderBottom: `1px solid ${theme.rule}`,
});

const tdStyle = () => ({
  padding: "12px 14px",
  verticalAlign: "middle" as const,
});

export function ExportTable({ fields, theme, fonts }: Props) {
  return (
    <div style={{ border: `1px solid ${theme.rule}`, background: theme.docPaper, overflow: "auto", maxHeight: 360 }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: fonts.sans, fontSize: 13, color: theme.ink }}>
        <thead>
          <tr style={{ background: theme.surface }}>
            <th style={thStyle(theme, fonts)}>Field</th>
            <th style={thStyle(theme, fonts)}>Type</th>
            <th style={thStyle(theme, fonts)}>Value</th>
            <th style={{ ...thStyle(theme, fonts), width: 84, textAlign: "right" }}>Conf.</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((f) => {
            const low = f.confidence < 0.8;
            return (
              <tr key={f.id} style={{ borderTop: `1px solid ${theme.rule}` }}>
                <td style={tdStyle()}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <TypeGlyph type={f.type} theme={theme} size={10} />
                    <span style={{ fontWeight: 500 }}>{f.label}</span>
                  </div>
                </td>
                <td
                  style={{
                    ...tdStyle(),
                    color: theme.inkMute,
                    fontFamily: fonts.mono,
                    fontSize: 11,
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                  }}
                >
                  {f.type.replace("_", " ")}
                </td>
                <td
                  style={{
                    ...tdStyle(),
                    fontFamily:
                      f.type === "currency" || f.type === "date" || f.type === "phone" ? fonts.mono : fonts.sans,
                  }}
                >
                  {f.value}
                </td>
                <td style={{ ...tdStyle(), textAlign: "right" }}>
                  <span style={{ fontFamily: fonts.mono, fontSize: 11, color: low ? theme.confidenceLow : theme.inkSoft }}>
                    {Math.round(f.confidence * 100)}%
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
